import { connect } from 'react-redux'
import LicenseChecker from '../../components/LicenseChecker/LicenseChecker'
import { decodeLicense, clearDecodedLicense, startLicenseFromRow } from '../../actions/index'

const mapStateToProps = state => {
    return {
        decoded: state.license.decodedLicense,
        isAdmin: state.auth.adminInfo === 1
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        decodeLicense: (text) => dispatch(decodeLicense(text)),
        clearDecodedLicense: () => dispatch(clearDecodedLicense()),
        startLicenseFromRow: (row) => dispatch(startLicenseFromRow(row))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LicenseChecker)
